import './App.scss';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Otp from './pages/auth/Otp';
import { URLS } from './_config';
import Subscription from './pages/auth/Subscription';
import AddOnsForm from './pages/auth/AddOnsForm';
import BusinessPlan from './pages/business_plan/BusinessPlan';
import PaymentMethod from './pages/payment_method/PaymentMethod';
import AboutUs from './pages/cms_pages/AboutUs';
import ContactUs from './pages/cms_pages/Contactus';
import MyBusinessPlan from './pages/user/MyBusinessPlan';
import MyAccount from './pages/user/MyAccount';
import Logout from './pages/auth/Logout';
import MyBusinessPlanDetails from './pages/user/MyBusinessPlanDetails';
import ThankYou from './pages/business_plan/ThankYou';
import EmailLogin from './pages/auth/EmailLogin';
// import Pay from './pages/stripe/Pay';
import Cms from './pages/cms_pages/Cms';

// import { loadStripe } from "@stripe/stripe-js"; 
import { PAYPAL_CLIENT_ID, STRIP_PUBLISHABLE_KEY } from './_config/site_urls';
import SignUp from './pages/auth/SignUp';
import TicketList from './pages/ticket/TicketList';
import TicketCreate from './pages/ticket/TicketCreate';
import TicketReply from './pages/ticket/TicketReply';
import PaymentForBusinessPlan from './pages/payment/PaymentForBusinessPlan';
import PaymentThankYou from './pages/payment/PaymentThankYou';
import AIAssistanceAns from './pages/business_plan/AIAssistanceAns';
import PaymentDetails from './pages/payment/PaymentDetails';
import ApproveOrRejectViaMail from './pages/business_plan/ApproveOrRejectViaMail';
import GeneralInfo from './pages/GeneralInfo'; 
import BlogNewsList from './pages/blogs_and_news/BlogNewsList';
import BlogDetails from './pages/blogs_and_news/BlogDetails';
import NewsDetails from './pages/blogs_and_news/NewsDetails';
import MenuPageDetails from './pages/menu_pages/MenuPageDetails';
import CommissionHistory from './pages/marketer/CommissionHistory';
import CustomersList from './pages/marketer/CustomersList';
import NotFoundPage from './pages/NotFoundPage';
import RouteMeta from './components/RouteMeta';

/**
 * Captures the affiliate referral code from the ?ref= query parameter on any
 * page load or navigation event and persists it as a SESSION COOKIE.
 *
 * A session cookie (30 days max-age / expires) is automatically cleared by the
 * browser when all windows are closed — matching the expected "cleared on
 * browser close" behaviour. It persists across tabs within the same session.
 *
 * First-click-wins: if affiliate_ref cookie is already set, subsequent ?ref=
 * params are ignored so the original referring marketer retains attribution.
 * The cookie is deleted after successful customer registration (SignUp.tsx).
 */
function AffiliateTracker() {
  const location = useLocation();

  useEffect(() => {
    const ref = new URLSearchParams(location.search).get('ref');
    if (ref && !document.cookie.match(/(^|;\s*)affiliate_ref=/)) {
      // 30 days max-age / expires → session cookie, cleared when browser closes
      document.cookie = `affiliate_ref=${encodeURIComponent(ref)}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`;
    }
  }, [location]);

  return null;
}

function App() {
  // Load the publishable key
  // const stripePromise = loadStripe(`${STRIP_PUBLISHABLE_KEY}`);
  // const paypalClientID = PAYPAL_CLIENT_ID;

  return (
    <BrowserRouter >
    {/* RouteMeta is the sole default owner of meta[name=robots]/meta[name=googlebot] for every
        route; MetaSection only overrides them when a page passes an explicit noindex boolean. */}
    <RouteMeta />
    <AffiliateTracker />
    <GeneralInfo />
      <div  >
        <Routes>
          <Route path={URLS.HOME} element={<Home />} />
          <Route path={URLS.LOGIN} element={<Login />} />
          <Route path={URLS.SIGN_UP} element={<SignUp />} />
          <Route path={URLS.EMAIL_LOGIN} element={<EmailLogin />} />
          <Route path={URLS.OTP} element={<Otp />} />
          <Route path={URLS.LOGOUT} element={<Logout />} />

          <Route path={URLS.SUBSCRIPTION} element={<Subscription />} />
          <Route path={URLS.ADDONS} element={<AddOnsForm />} />
          <Route path={URLS.BUSINESS_PLAN} element={<BusinessPlan />} />
          <Route path={URLS.THANKYOU_PAGE} element={<ThankYou />} />
          <Route path={URLS.AI_ASSISTANCE_ANS} element={<AIAssistanceAns />} />
          <Route path={URLS.PAYMENT_METHOD} element={<PaymentMethod />} />


          <Route path={URLS.ACCOUNT.MY_ACCOUNT} element={<MyAccount />} />
          <Route path={URLS.ACCOUNT.MY_BUSINESS_PLAN} element={<MyBusinessPlan />} />
          <Route path={URLS.ACCOUNT.MY_BUSINESS_PLAN_DETAILS} element={<MyBusinessPlanDetails />} />
          <Route path={URLS.ACCOUNT.PAYMENT.PRICE_DETAILS} element={<PaymentDetails />} />
          <Route path={URLS.ACCOUNT.PAYMENT.PAY} element={<PaymentForBusinessPlan />} />
          <Route path={URLS.ACCOUNT.PAYMENT.THANK_YOU} element={<PaymentThankYou />} />

          <Route path={URLS.ACCOUNT.TICKET.LIST} element={<TicketList />} />
          <Route path={URLS.ACCOUNT.TICKET.CREATE} element={<TicketCreate />} />
          <Route path={URLS.ACCOUNT.TICKET.REPLY} element={<TicketReply />} />


          <Route path={URLS.PAYMENT.PAY} element={<PaymentMethod />} />

          {/* <Elements stripe={stripePromise}>
            <CheckoutForm />
          </Elements> */}

          <Route path={URLS.APPROVE_OR_REJECT} element={<ApproveOrRejectViaMail />} />


          <Route path={URLS.CMS_PAGES.CMS_LINK} element={<Cms />} />

          <Route path={URLS.CMS_PAGES.ABOUT_US} element={<AboutUs />} />
          <Route path={URLS.CMS_PAGES.CONTACT_US} element={<ContactUs />} />
          
          <Route path={URLS.MENU_PAGES.PAGE_DETAILS} element={<MenuPageDetails />} />
          <Route path={URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_CAT} element={<MenuPageDetails />} />
          <Route path={URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_CHILD} element={<MenuPageDetails />} />
          <Route path={URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_PAGE} element={<MenuPageDetails />} />

          <Route path={URLS.BLOG_NEWS.LIST} element={<BlogNewsList />} />
          <Route path={URLS.BLOG_NEWS.BLOG_DETAILS} element={<BlogDetails />} />
          <Route path={URLS.BLOG_NEWS.NEWS_DETAILS} element={<NewsDetails />} />

          <Route path={URLS.MARKETER.COMMISSION_HISTORY} element={<CommissionHistory />} />
          <Route path={URLS.MARKETER.CUSTOMERS} element={<CustomersList />} />
          
          <Route path={URLS.NOT_FOUND} element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
